import { app } from '@/bootloader';

app.directive('incredi-input-num-type', {
  created: el => {
    el.addEventListener('keydown', (event: KeyboardEvent) => {
      const blacklist = new Set([69, 107, 109, 110]);
      if (blacklist.has(event.keyCode)) {
        event.preventDefault();
      }
    });
  },
});
